import { Table, Skeleton } from "@mantine/core";

interface LoadingTableProps {
  rows?: number;
  columns?: number;
}

export function LoadingTable({ rows = 5, columns = 4 }: LoadingTableProps) {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {Array.from({ length: columns }).map((_, i) => (
            <Table.Th key={i}>
              <Skeleton height={14} width={`${60 + Math.random() * 40}%`} />
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <Table.Tr key={rowIdx}>
            {Array.from({ length: columns }).map((_, colIdx) => (
              <Table.Td key={colIdx}>
                <Skeleton height={14} width={`${50 + Math.random() * 50}%`} />
              </Table.Td>
            ))}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
}
